const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const { format, subMonths } = require('date-fns');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');
const DOCSIGN_API_SETTIMEOUT_CODES = require('../../constants');
function getQS(parsedMetaData) {
  return {
    pfRelId: parsedMetaData.portfolio.pfRelId,
    branchCode: parsedMetaData.portfolio.branchCode
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    showUserBanner(inputs, metaData) {
      const url = getUrl('showUserBanner');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        dwoFunction: inputParams[0],
        branchCode: parsedMetaData.portfolio.branchCode,
        pfId: parsedMetaData.portfolio.pfRelId
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },



    saveUserSeenBanner(inputs, metaData) {
      const url = getUrl('saveUserSeenBanner');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        dwoFunction: inputParams[0],
        pfId: parsedMetaData.portfolio.pfRelId
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getEligibleClientList(inputs, metaData) {
      const url = getUrl('eligibleClientSign');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        pfId: inputParams[0]
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getEligiblePfList(inputs, metaData) {
      const url = getUrl('eligiblePfSign');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getDocumentTypeList(inputs, metaData) {
      const url = getUrl('templateDropDown');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getDocumentListForAdmin(inputs, metaData) {
      const url = getUrl('listEnvelope');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        pfIds: [inputParams[0].toString().substring(1, inputParams[0].toString().length)],
        pageNumber: inputParams[1].toString().substring(1, inputParams[1].toString().length),
        pagesize: inputParams[2].toString().substring(1, inputParams[2].toString().length),
        sortColumn: inputParams[3],
        sortOrder: inputParams[4],
        excelExportFlag: inputParams[5],
        filterOptions: JSON.parse(base64.decode(inputParams[6]))
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    manageUserDocument(inputs, metaData) {
      const url = getUrl('manageUserDsDoc');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'PUT', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        dsDocId: inputParams[0].toString().substring(1, inputParams[0].toString().length),
        action: inputParams[1],
        pfId: inputParams[2].toString().substring(1, inputParams[2].toString().length),
        branchCode: inputParams[3].toString().substring(1, inputParams[3].toString().length)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    saveClientSub(inputs, metaData) {
      const url = getUrl('saveClientSub');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const ackStatus = JSON.parse(base64.decode(inputParams[1]));
      const body = {
        userId: parsedMetaData.qs.userId,
        dwoFunction: inputParams[0],
        ackStatus: ackStatus,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getClientSub(inputs, metaData) {
      const url = getUrl('getClientSub');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        dwoFunction: inputParams[0],
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getDocumentList(inputs, metaData) {
      const url = getUrl('viewClientDsDoc');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        pfId: parsedMetaData.portfolio.pfRelId,
        status: inputParams[0],
        pageNumber: inputParams[1].toString(),
        numberOfRecords: inputParams[2].toString(),
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getAcceptView(inputs, metaData) {
      const url = getUrl('dsAcceptView');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        dwoDocId: parseInt(inputParams[0], 10)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getActionAccept(inputs, metaData) {
      const url = getUrl('dsActionAccept');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'PUT', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      let body = {};
      if (inputParams[2]) {
        body = {
          userId: parsedMetaData.qs.userId,
          branchCode: parsedMetaData.portfolio.branchCode,
          txId: inputParams[0],
          action: inputParams[1],
          comments: inputParams[2]
        };
      } else {
        body = {
          userId: parsedMetaData.qs.userId,
          branchCode: parsedMetaData.portfolio.branchCode,
          txId: inputParams[0],
          action: inputParams[1]
        };
      }

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getDocuSignWebURL(inputs, metaData) {
      const url = getUrl('dsRecipientView');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        documentId: parseInt(inputParams[0], 10)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },


    completeDocumentSign(inputs, metaData) {
      const url = getUrl('completeSignature');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        txId: parseInt(inputParams[0], 10),
        event: inputParams[1]
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },


    getSignedDocument(inputs, metaData) {
      const url = getUrl('viewSignedDoc');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        documentId: parseInt(inputParams[0], 10)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getRmTeamList(inputs, metaData) {
      const url = getUrl('getRmTeamList');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    searchRmName(inputs, metaData) {
      const url = getUrl('getRmNames');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        rmName: inputParams[0].toString().substring(1, inputParams[0].toString().length),
        pageNumber: inputParams[1].toString().substring(1, inputParams[1].toString().length),
        pagesize: inputParams[2].toString().substring(1, inputParams[2].toString().length)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    searchClientName(inputs, metaData) {
      const url = getUrl('getClientNames');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        clientName: inputParams[0].toString().substring(1, inputParams[0].toString().length),
        pageNumber: inputParams[1].toString().substring(1, inputParams[1].toString().length),
        pagesize: inputParams[2].toString().substring(1, inputParams[2].toString().length)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    searchOrderId(inputs, metaData) {
      const url = getUrl('getOrderIdList');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        orderId: inputParams[0].toString().substring(1, inputParams[0].toString().length),
        pageNumber: inputParams[1].toString().substring(1, inputParams[1].toString().length),
        pagesize: inputParams[2].toString().substring(1, inputParams[2].toString().length)
      };
      
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    searchDocumentName(inputs, metaData) {
      const url = getUrl('getDocumentNameList ');
      const inputParams = inputs.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true, timeout: DOCSIGN_API_SETTIMEOUT_CODES.DELAY}
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        documentName: inputParams[0].toString().substring(1, inputParams[0].toString().length),
        pageNumber: inputParams[1].toString().substring(1, inputParams[1].toString().length),
        pagesize: inputParams[2].toString().substring(1, inputParams[2].toString().length)
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    }
  }
}

module.exports = apiFactory;